import { configure } from '@castleio/castle-js';
import { useEffect } from 'react';
import { UNIVERSAL_ENV_VARS } from '../../constants/environmentVariables';
import { useClientHasRendered } from '../hooks';

export let castle: ReturnType<typeof configure> | null = null;

export function useCastle() {
  // TODO: Better to enapsulate this, but the auth flow is fucked and I'd have to rewrite a million things to get the
  // hook in the right place :(
  // const castle = useRef<ReturnType<typeof Castle.configure> | null>(null);
  const clientHasRendered = useClientHasRendered();

  useEffect(() => {
    if (clientHasRendered && !castle) {
      castle = configure({ pk: UNIVERSAL_ENV_VARS.CASTLE_PUBLIC_KEY });
    }
  }, [clientHasRendered]);

  return castle;
}
